import { COMMUNITY_ERRORS } from "../community/community-errors.js";
import { USER_ERRORS } from "../user/user-errors.js";

export const INVITATION_ERRORS = {
	NOT_FOUND: "invitation_not_found",
	ALREADY_ACCEPTED: "invitation_already_accepted",
	COMMUNITY_NOT_FOUND: COMMUNITY_ERRORS.NOT_FOUND,
	USER_NOT_FOUND: USER_ERRORS.NOT_FOUND,
} as const;

export type InvitationErrorCode = (typeof INVITATION_ERRORS)[keyof typeof INVITATION_ERRORS];
